<template>
  <div class="outter">
    <div class="innerbook">
      <div class="textHeader">
        <p class="modelText">查看样书申请详情</p>
        <div class="close" @click="close">
          <img src="../../assets/img/close.png" alt="" />
        </div>
      </div>
      <div class="middle">
        <ul class="demoBookDetail clearfix">
          <li>申请状态: {{ status[sonValue.stylebookAuditType] }}</li>
          <li v-show="sonValue.stylebookAuditType == 2">
            货单号: {{ sonValue.ems }}
          </li>
          <li>姓&nbsp;&nbsp;名: {{ image.name }}</li>
          <li>学&nbsp;&nbsp;校: {{ sonValue.schoolName }}</li>
          <li>
            职&nbsp;&nbsp;称:
            {{ getzhichengStr(parseInt(sonValue.professional)) }}
          </li>
          <li>手&nbsp;&nbsp;机: {{ sonValue.mobilephone }}</li>
          <li>样书数量: {{ sonValue.stylebookNumber }}本</li>
          <li>预计用书量: {{ sonValue.anticipatedNumber }}本</li>
          <li style="width: 100%" v-show="sonValue.stylebookAuditType == 3">
            拒绝原因: {{ sonValue.refusalCase }}
          </li>
          <li style="width: 100%">寄送地址: {{ sonValue.address }}</li>
          <li style="width: 100%; lineheight: 25px">
            备&nbsp;&nbsp;注: {{ sonValue.description }}
          </li>
          <!-- -->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getzhichengStr } from '../../assets/tool'
export default {
  props: {
    sonValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      num7: 1,
      image: {},
      status: {
        1: '待处理',
        2: '已处理',
        3: '已拒绝',
      },
      getzhichengStr: getzhichengStr,
    }
  },
  created() {
    var vuex = JSON.parse(localStorage.getItem('vuex'))
    this.getLocalStorage(vuex)
  },
  methods: {
    getLocalStorage(vuex) {
      this.image = vuex
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style >
.inputNumber {
  width: 100px !important;
}
.elSelect {
  width: 130px;
  height: 30px;
}
.elSelect .el-input__inner {
  height: 30px;
}
.elSelect .el-input__icon {
  line-height: 30px;
}
</style>
<style lang="scss" scoped>
.demoBookDetail {
  padding-left: 20px;
}
.demoBookDetail li {
  width: 50%;
  float: left;
  color: #444444;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
}
.button {
  width: 60px;
  height: 28px;
  background: #0082f0;
  border-radius: 4px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  margin-top: 44px;
}
.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-top: 20px;
  margin-bottom: 10px;
}
.middle {
  padding-top: 10px;
  height: 240px;
  overflow: auto;
}
::-webkit-scrollbar {
  display: none;
}
.textHeader {
  position: relative;
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
}
.close img {
  width: 14px;
  height: 14px;
}
.modelText {
  width: 458px;
  height: 30px;
  background: #fff8f7;
  padding-left: 22px;
  line-height: 30px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.outter {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.innerbook {
  width: 480px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background: #ffffff;
  border: 1px solid #cccccc;
  height: 300px;
  max-height: 300px;
}
</style>
